import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../store/theme.actions';

import NotasFiscaisDevedorProvider from '../../store/NotasFiscaisDevedor/NotaFiscalDevedorProvider';
import { NotasFiscaisDevedor } from './NotasFiscaisDevedor';
import ContaCorrenteClienteProvider from '../../store/ContaCorrenteCliente/ContaCorrenteClienteProvider';

function NotasFiscaisDevedorPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Notas Fiscais de Devedores'));
  return (
    <NotasFiscaisDevedorProvider>
      <ContaCorrenteClienteProvider>
        <NotasFiscaisDevedor />
      </ContaCorrenteClienteProvider>
    </NotasFiscaisDevedorProvider>
  );
}

export default withTokenInterceptor(NotasFiscaisDevedorPage);
